var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .camera-st0{fill:#FFFFFF;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "camera-st0",
    d: "M283.7,339.5H159c-10.1,0-18.2-8.2-18.2-18.2v-96.6c0-10.1,8.2-18.2,18.2-18.2h124.7     c10.1,0,18.2,8.2,18.2,18.2v96.6C301.9,331.3,293.7,339.5,283.7,339.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "camera-st0",
    d: "M358.4,316.4l-34.3-20.5c-2.3-1.3-3.6-3.6-3.6-6v-63.2c0-2.4,1.3-4.6,3.6-6l34.3-20.5c5.5-3.3,12.9,0.2,12.9,6     v104.2C371.2,316.2,363.9,319.7,358.4,316.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "camera-st0",
    d: "M226.8,172.5h-38.3c-5.7,0-10.4,4.7-10.4,10.4v0c0,5.7,4.7,10.4,10.4,10.4h38.3c5.7,0,10.4-4.7,10.4-10.4v0     C237.2,177.2,232.6,172.5,226.8,172.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.3474ccd98b94ae26c0eb5cd9e96152a7.svg";
export { ForwardRef as ReactComponent };